import request from '@/utils/service'

export function addPartnerApi(data) {
  return request({
    url: '/partner/add',
    method: 'post',
    data
  })
}

export function updatePartnerApi(data) {
  return request({
    url: '/partner/update',
    method: 'post',
    data
  })
}

export function parentsStatusApi(data) {
  return request({
    url: '/partner/updateStatus',
    method: 'post',
    data
  })
}

export function delPartnerApi(data) {
  return request({
    url: '/partner/delete',
    method: 'post',
    data
  })
}

export function partnersListApi(data) {
  console.log('params :>> ', data)
  return request({
    url: '/partner/list',
    method: 'get',
    params: data
  })
}

export function partnersLevelApi(key) {
  return request({
    url: `/setting/detail/${key}`,
    method: 'get',
    params: {}
  })
}

export function partnersEquApi(data) {
  return request({
    url: '/partner/devices',
    method: 'get',
    params: data
  })
}

export function partnerRechargeOrder(data) {
  return request({
    url: '/xdWalletTxFlow/recharge/flow',
    method: 'get',
    params: data
  })
}
